import React, { useEffect, useState } from "react";
import Editor from "../../../form/Editor";
import Select from "../../../form/select/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { faqAddEdit } from "../../../../services/faqService";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { faqDetails } from "../../../../services/faqService";
import Tabs from "../../../elements/Tabs";

const validation = {
  title: { required: true, message: "Question is required" },
  excerpt: { required: true, message: "Answer is required" },
};

function FormComponent({
  getResponse = () => {},
  close = () => {},
  data,
  lang,
}) {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });
  const queryClient = useQueryClient();

  console.log({ data });

  const { data: details } = useQuery({
    queryKey: ["details", data?._id],
    queryFn: async () => {
      const res = await faqDetails({ id: data?._id });
      return res;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: ["details", data?._id] });
    };
  }, []);

  useEffect(() => {
    if (details?.data?._id) {
      if (details?.status === 200) {
        const payload = {
          title: details?.data?.title?.[lang] || "",
          excerpt: details?.data?.excerpt?.[lang] || "",
          visibility: details?.data?.visibility,
          status: details?.data?.status,
        };
        delete payload?._id;
        if (
          payload &&
          typeof payload === "object" &&
          Object.keys(payload)?.length > 0
        ) {
          setFieldsValue(payload);
        }
      }
    }
  }, [details?.data?._id, lang]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        title: { ...details?.data?.title, [lang]: val?.title },
        excerpt: {
          ...details?.data?.excerpt,
          [lang]: val?.excerpt,
        },
      };
      return await faqAddEdit({
        ...payload,
        type: "faq",
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  console.log({ errors });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-4">
          <Editor
            label="FAQ Question"
            placeholder="Who is the V’Peters"
            value={values?.title}
            onChange={(val) =>
              handleChange({ target: { name: "title", value: val } })
            }
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label="FAQ Answer"
            placeholder="the V’Peters are People"
            value={values?.excerpt}
            onChange={(val) =>
              handleChange({
                target: { name: "excerpt", value: val },
              })
            }
            {...formValidate(errors, "excerpt")}
          />
        </div>
        <div className="relative col-span-2">
          <Select
            label={"Visibility"}
            placeholder="Select Visibility"
            selectedValue={values?.visibility}
            dropdownData={[
              { name: "Public", value: "public" },
              { name: "Private", value: "private" },
              { name: "Password", value: "password" },
            ]}
            onChange={(val) => {
              handleChange({ target: { name: "visibility", value: val } });
            }}
            {...formValidate(errors, "visibility")}
          />
        </div>

        <div className="relative col-span-2">
          <Select
            label={"Status"}
            placeholder="Select Status"
            selectedValue={values?.status}
            dropdownData={[
              { name: "Draft", value: "draft" },
              { name: "Published", value: "published" },
              { name: "Private", value: "private" },
              { name: "Trash", value: "trash" },
            ]}
            onChange={(val) => {
              handleChange({ target: { name: "status", value: val } });
            }}
            {...formValidate(errors, "status")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save FAQ"}
            variant="secondary"
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            variant="primary"
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
}

const ManageFaq = ({ getResponse = () => {}, close = () => {}, data }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const tabs = [
    {
      label: "English",
      content: (
        <FormComponent
          getResponse={getResponse}
          close={close}
          data={data}
          lang={"en"}
        />
      ),
    },
    {
      label: "Spanish",
      content: (
        <FormComponent
          getResponse={getResponse}
          close={close}
          data={data}
          lang={"es"}
        />
      ),
    },
  ];

  return (
    <div className="h-full p-4">
      <Tabs
        items={tabs}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
      />
    </div>
  );
};

export default ManageFaq;
